import type { FC } from "react";

import { browserStatics } from "@/src/shared/BrowserStatic";
import type { IComponent } from "@Components/Component";
import { defaultAttributes } from "@Components/Component";
import type { IImageLoader } from "@Components/ImageLoader";
import ImageLoader from "@Components/ImageLoader";
import { Link, LinkTarget } from "@Components/Link";

import * as css from "./LoyaltyDownloadPanel.module.css";

export interface ILoyaltyDownloadPanel extends IComponent {
    title: string;
    description?: string;
    imageGoogleStore?: IImageLoader;
    linkGoogleStore?: string;
    imageAppleStore?: IImageLoader;
    linkAppleStore?: string;
}

const getStoreButton = (
    storeLink: string | undefined,
    imageStore: IImageLoader | undefined,
    browserOs: string,
    platform: string,
) => {
    if (!browserOs || !imageStore || !storeLink || browserOs === platform) {
        return null;
    }

    return (
        <div className={css.linkAction}>
            <Link navigateUrl={storeLink} target={LinkTarget.Blank} hideMainLoading={true}>
                <ImageLoader {...imageStore} />
            </Link>
        </div>
    );
};

const LoyaltyDownloadPanel: FC<ILoyaltyDownloadPanel> = (props) => {
    const { browserOs } = browserStatics;

    return (
        <div {...defaultAttributes(props, css.loyaltyDownloadPanelComponent)}>
            <div className={css.appTitle}>{props.title}</div>
            <div className={css.appDownloadIcons}>
                {getStoreButton(props.linkGoogleStore, props.imageGoogleStore, browserOs || "", "IOS")}
                {getStoreButton(props.linkAppleStore, props.imageAppleStore, browserOs || "", "ANDROID")}
            </div>
            {props.description && (
                <div className={css.description}>
                    <h3>{props.description}</h3>
                </div>
            )}
        </div>
    );
};

export default LoyaltyDownloadPanel;
